import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    flex-flow: column nowrap;
    min-height: 100vh;
  `,
  content: css`
    display: flex;
    flex-direction: column;
    padding: 0px 16px 26px 16px;
  `,
  subHeader: css`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding: 4px 0px 8px;
  `,
  footer: css`
    opacity: 0.5;
    pointer-events: none;
  `,
};

export default styles;
